import { render } from "./superbowlvegas.vue?vue&type=template&id=57c4c243"
import script from "./superbowlvegas.vue?vue&type=script&lang=js"
export * from "./superbowlvegas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__